import React from "react"

import ChildrenIcon from "@/components/venue_tags/icons/children"
import CuisineIcon from "@/components/venue_tags/icons/cuisine"
import DressCodeIcon from "@/components/venue_tags/icons/dress_code"
import KitchenHoursIcon from "@/components/venue_tags/icons/kitchen_hours"
import MealIcon from "@/components/venue_tags/icons/meal"
import ParkingIcon from "@/components/venue_tags/icons/parking"
import PaymentsIcon from "@/components/venue_tags/icons/payments"
import PetsIcon from "@/components/venue_tags/icons/pets"
import PriceRangeIcon from "@/components/venue_tags/icons/price_range"
import TimeLimitIcon from "@/components/venue_tags/icons/time_limit"
import VenueTypeIcon from "@/components/venue_tags/icons/venue_type"
import WheelchairAccessIcon from "@/components/venue_tags/icons/wheelchair_access"
import type { TagCategory } from "@/components/venue_tags/types"

export const TAG_CATEGORY_ICONS: Record<TagCategory, React.FC<React.SVGProps<SVGSVGElement>>> = {
  venue_type: VenueTypeIcon,
  cuisine: CuisineIcon,
  meal: MealIcon,
  payments: PaymentsIcon,
  time_limit: TimeLimitIcon,
  price_range: PriceRangeIcon,
  parking: ParkingIcon,
  wheelchair_access: WheelchairAccessIcon,
  dress_code: DressCodeIcon,
  kitchen_hours: KitchenHoursIcon,
  children: ChildrenIcon,
  pets: PetsIcon,
}

export const DISPLAY_CATEGORIES: TagCategory[] = [
  "cuisine",
  "meal",
  "payments",
  "time_limit",
  "price_range",
  "parking",
  "wheelchair_access",
  "dress_code",
  "kitchen_hours",
  "children",
  "pets",
]

export const CATEGORY_DISPLAY_ORDER: TagCategory[] = [
  "venue_type",
  "cuisine",
  "time_limit",
  "price_range",
  "dress_code",
  "kitchen_hours",
  "meal",
  "payments",
  "parking",
  "wheelchair_access",
  "children",
  "pets",
]
